define('utils/dom_helper',{

  hasClass: function(dom, className){
    var classNameWithSpace = ' ' + className + ' ';
    return classNameWithSpace.indexOf(' ' + dom.className + ' ') >= 0
  },

  addClass: function(dom, className){
    if(!this.hasClass(dom, className)){
      dom.className = dom.className ? dom.className + ' ' + className : className;
    }
  },

  removeClass: function(dom, className){
    if(this.hasClass(dom, className)){
      var regExp = new RegExp('(?:^|\\s)' + className + '(?!\\S)', 'g');
      dom.className = dom.className.replace(regExp,'').trim();
    }
  },

  // Deprecated 2016, please use addEventListener instead.
  on: function(target, ev, fn) {
    if (window.attachEvent){
      target.attachEvent("on" + ev, fn);
    }
    else {
      target.addEventListener(ev, fn, false);
    }
  },

  addEventListener: function(obj, evt, func) {
    if ('addEventListener' in window) {
      obj.addEventListener(evt, func, false);
    } else if ('attachEvent' in window) {//IE
      obj.attachEvent('on' + evt, func);
    }
  },

  removeEventListener: function(obj, evt, func) {
    if ('removeEventListener' in window) {
      obj.removeEventListener(evt, func, false);
    } else if ('detachEvent' in window) {//IE
      obj.detachEvent('on' + evt, func);
    }
  }


})
;
